module.exports = __webpack_public_path__ + "static/media/credit-card (1)-1.d3a3e79d.svg";